import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["background", "children", "icon", "iconBackgroundColor", "iconColorSet", "variant"];
import React from 'react';
import { renamedPropWarning } from "../../deprecationWarnings";
import { addColorSet } from "../../styles";
import { Background } from "./Background";
import { Icon } from "./Icon";
import { IconContainer } from "./IconContainer";
import { MessageContainer } from "./MessageContainer";
export var EmptyState = function EmptyState(_ref) {
  var background = _ref.background,
      children = _ref.children,
      icon = _ref.icon,
      iconBackgroundColor = _ref.iconBackgroundColor,
      _ref$iconColorSet = _ref.iconColorSet,
      iconColorSet = _ref$iconColorSet === void 0 ? 'announcement' : _ref$iconColorSet,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'fullscreen' : _ref$variant,
      props = _objectWithoutProperties(_ref, _excluded);

  if (iconBackgroundColor) renamedPropWarning('iconBackgroundColor', 'iconColorSet');
  return /*#__PURE__*/React.createElement(Background, Object.assign({
    background: background,
    variant: variant
  }, props), /*#__PURE__*/React.createElement(MessageContainer, {
    background: background,
    variant: variant
  }, icon && /*#__PURE__*/React.createElement(IconContainer, {
    className: addColorSet(iconColorSet)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    "aria-hidden": "true"
  })), children));
};
/**
* **EmptyState** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EmptyState) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-emptystate--default) |  
*
* EmptyState is used when no other content or information is available. It tells the user what they can expect to find there in the future and suggests a next step.
*
* @example
* () => (
*  <EmptyState icon={IconTrending}>
*    <EmptyStateTitle>Lorem ipsum dolor</EmptyStateTitle>
*    <EmptyStateText>Pellentesque hendrerit ipsum ultrices augue tempor finibus.</EmptyStateText>
*    <EmptyStateButton>Call for help!</EmptyStateButton>
*  </EmptyState>
*);
*
*/

export default EmptyState;